import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// components
import Header from '../../../components/Header/Header';
import Form from '../../../components/Form/Form';
import Button from '../../../components/Button/Button';
import Breadcrumbs from '../../../components/Breadcrumbs';

// icons
import icon from '../../../brand/generated/sidebar/report.svg';
import HookForm from '../../../components/HookForm/HookForm';
import Select from '../../../components/Select/Select';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';
import DownloadFileLink from '../../../components/DownloadFileLink/DownloadFileLink';
import alert from '../../../helpers/alert';
import downloadReport from '../../../api/reports/downloadReport';

/** Ð¡Ð¾ÑÑÐ°Ð½ÑÐµÑ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð½ÑÐ¹ ÑÐ°Ð¹Ð»: Ð¾ÑÐ´Ð°ÑÐ¼ ÐµÐ³Ð¾ Ð±ÑÐ°ÑÐ·ÐµÑÑ Ð¿Ð¾Ð´ Ð¿Ð¾Ð½ÑÑÐ½ÑÐ¼ Ð¸Ð¼ÐµÐ½ÐµÐ¼. */
const saveFile = (blob, title, from, to) => {
  const name = [title || 'ÐÑÑÐµÑ', from, to].filter(Boolean).join(' ') + '.xlsx';
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Ð¡ÑÑÐ»ÐºÑ Ð´ÐµÑÐ¶Ð¸Ñ Ð±ÑÐ°ÑÐ·ÐµÑ, Ð¿Ð¾ÐºÐ° ÐµÑ Ð½Ðµ Ð¾ÑÐ²Ð¾Ð±Ð¾Ð´Ð¸ÑÑ, â ÑÐ°Ð¹Ð» Ð¾ÑÑÐ°ÑÑÑÑ Ð² Ð¿Ð°Ð¼ÑÑÐ¸.
  window.URL.revokeObjectURL(url);
};

const formStyles = {
  report: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a a' 'c c b b'` },
};

// Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð¾ÑÑÐµÑÐ¾Ð²
const reportOptions = [
  { id: 1, title: 'Ð¡Ð¿Ð¸ÑÐ¾Ðº ÑÑÐ¿ÐµÑÐ½ÑÑ ÑÐ´ÐµÐ»Ð¾Ðº' },
  { id: 2, title: 'Ð¡Ð¿Ð¸ÑÐ¾Ðº ÑÐ´ÐµÐ»Ð¾Ðº Ñ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸ÐµÐ¼ Ð±Ð°Ð½ÐºÐ¾Ð²' },
  { id: 3, title: 'Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð¾ÑÐºÐ°Ð·Ð°Ð½Ð½ÑÑ ÑÐ´ÐµÐ»Ð¾Ðº' },
  { id: 4, title: 'ÐÐ»Ð¸ÐµÐ½ÑÑ, ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¿ÑÐ¾ÑÐµÐ´ÑÐ¸Ðµ ÐÐÐ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ' },
  { id: 5, title: 'ÐÐ»Ð¸ÐµÐ½ÑÑ, Ð¿ÑÐ¾ÑÐµÐ´ÑÐ¸Ðµ ÐÐÐ ÑÐµÑÑ Ð¸ Ð¿Ð¾Ð»ÑÑÐ¸Ð²ÑÐ¸Ðµ Ð¾ÑÐºÐ°Ð·' },
  { id: 6, title: 'ÐÐ»Ð¸ÐµÐ½ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐ¼ Ð´Ð²Ð°Ð¶Ð´Ñ Ð¾ÑÐºÐ°Ð·Ð°Ð»Ð¸ Ð²ÑÐµ Ð±Ð°Ð½ÐºÐ¸' },
  { id: 7, title: 'ÐÐ¾ÑÐ¾Ð½ÐºÐ° Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ' },
];

const formData = [
  {
    component: Datepicker,
    name: 'from',
    label: 'ÐÑÑÐµÑÐ½ÑÐ¹ Ð¿ÐµÑÐ¸Ð¾Ð´ Ñ',
    placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
    rules: {
      required: true,
    },
  },
  {
    component: Datepicker,
    name: 'to',
    label: 'ÐÑÑÐµÑÐ½ÑÐ¹ Ð¿ÐµÑÐ¸Ð¾Ð´ Ð´Ð¾',
    placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
    rules: {
      required: true,
    },
  },
  {
    component: Select,
    label: 'Ð¢Ð¸Ð¿ Ð¾ÑÑÐµÑÐ°',
    name: 'reportType',
    options: reportOptions.map((r) => ({ value: r.id, label: r.title })),
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¾ÑÑÐµÑ',
    rules: {
      required: true,
    },
  },
]

const ReportCreate = () => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async (values) => {
    setLoading(true);

    try {
      // ÐÐ°Ð¿ÑÐ¾Ñ Ð¸Ð´ÑÑ ÑÐµÑÐµÐ· Ð½Ð°Ñ Ð±ÑÐºÐµÐ½Ð´: Ð¾Ð½ ÑÐ°Ð¼ ÑÐ¾Ð´Ð¸Ñ Ð² Ð°Ð´Ð¼Ð¸Ð½ÐºÑ Ð¸ Ð¾ÑÐ´Ð°ÑÑ Ð³Ð¾ÑÐ¾Ð²ÑÐ¹
      // ÑÐ°Ð¹Ð». Ð Ð°Ð½ÑÑÐµ Ð±ÑÐ°ÑÐ·ÐµÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° ÑÑÑÑÐ°Ð»ÑÑ Ð½Ð° admin.doscar.kz Ð½Ð°Ð¿ÑÑÐ¼ÑÑ, Ð¸
      // Ñ ÑÐµÑ, Ñ ÐºÐ¾Ð³Ð¾ Ð½ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð° Ðº Ð°Ð´Ð¼Ð¸Ð½ÐºÐµ, ÑÐºÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ðµ Ð¿Ð°Ð´Ð°Ð»Ð¾. ÐÐ°Ð¾Ð´Ð½Ð¾ ÑÐµÑÑÐ¾Ð²ÑÐ¹
      // ÐºÐ¾Ð½ÑÑÑ Ð¿ÐµÑÐµÑÑÐ°Ð» Ð·Ð°Ð±Ð¸ÑÐ°ÑÑ Ð¾ÑÑÑÑÑ Ð¸Ð· Ð±Ð¾ÐµÐ²Ð¾Ð¹ Ð°Ð´Ð¼Ð¸Ð½ÐºÐ¸.
      const response = await downloadReport({
        id: values?.reportType?.value,
        title: values?.reportType?.label,
        date: { from: values?.from, to: values?.to },
      });

      saveFile(response.data, values?.reportType?.label, values?.from, values?.to);
    } catch (error) {
      alert.error(error);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header title="ÐÐ¾Ð²ÑÐ¹ Ð¾ÑÑÐµÑ" icon={icon} />
      <Breadcrumbs navigate={'/reports'} link={'ÐÐ¾Ð¸ Ð¾ÑÑÐµÑÑ'} currentPage={'ÐÐ¾Ð²ÑÐ¹ Ð¾ÑÑÐµÑ'} />
      <HookForm
        inputs={formData}
        title={'ÐÑÑÐµÑ'}
        grid={formStyles.report}
        onSubmit={handleDownload}
        border
        action="Ð¡ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¾ÑÑÐµÑ"
        loading={loading}
      />
    </>
  );
};

export default ReportCreate;
